/**
 * eDesk REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents one object of an electronic message (equivalent of object complexType from MessageContainer.xsd)
 */
export interface OutputMessageObject { 
    /**
     * Identifikátor objektu (GUID) - generovaná hodnota, kvôli referencovaniu
     */
    id: string;
    /**
     * Názov objektu, obyčajne názov pôvodného súboru
     */
    name: string | null;
    /**
     * Popis objektu, určený na zobrazenie
     */
    description?: string | null;
    /**
     * Trieda objektu, slúži na identifikovanie typu, resp. účelu.
     */
    'class': OutputMessageObject.ClassEnum;
    /**
     * Príznak, či objekt je podpísaný
     */
    isSigned: boolean | null;
    /**
     * Typ obsahu objektu, určuje dátový formát objektu
     */
    mimeType: string;
    /**
     * Object content — Base64-encoded binary data 
     */
    content: string;
}
export namespace OutputMessageObject {
    export const ClassEnum = {
        Form: 'FORM',
        Attachment: 'ATTACHMENT'
    } as const;
    export type ClassEnum = typeof ClassEnum[keyof typeof ClassEnum];
}


